// Delivery platforms ("Plataformas" selling option) shared between the
// settings page (account/prefs/sales.tsx, where the restaurant picks which
// apps they sell through) and the POS order-type picker (which only shows
// platforms the restaurant activated). Stored as a single JSON-encoded
// settings value (pref_key "platforms_enabled") since the generic settings
// system is flat key/value.

export const FIXED_PLATFORM_OPTIONS = ["Uber Eats", "Rappi", "Didi Food"];

export function parsePlatformsEnabled(raw: unknown): string[] {
  if (Array.isArray(raw)) {
    return raw.filter((v): v is string => typeof v === "string" && v.length > 0);
  }
  if (typeof raw !== "string" || !raw) return [];
  try {
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((v): v is string => typeof v === "string" && v.length > 0);
  } catch {
    return [];
  }
}

export function serializePlatformsEnabled(platforms: string[]): string {
  return JSON.stringify(platforms);
}

// Sales dashboard breakdown keys other_apps entries as "other_apps:<name>"
// (see getSalesDashboard.js) so each platform gets its own slice instead of
// one "Otras Plataformas" bucket. These helpers turn that key into a label
// and a stable color for charts/tables.
const PLATFORM_KEY_PREFIX = "other_apps:";

export function isPlatformBreakdownKey(type: string): boolean {
  return type.startsWith(PLATFORM_KEY_PREFIX);
}

export function platformNameFromBreakdownKey(type: string): string {
  return type.slice(PLATFORM_KEY_PREFIX.length);
}

// Small rotating palette (variations on the existing other_apps red) so
// multiple platform slices stay visually distinct in the same chart.
const PLATFORM_COLOR_PALETTE = ["#f56144", "#d6432a", "#ff8a6b", "#b8331c", "#ff5a8c"];

export function platformBreakdownColor(type: string): string {
  const name = platformNameFromBreakdownKey(type);
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
  }
  return PLATFORM_COLOR_PALETTE[hash % PLATFORM_COLOR_PALETTE.length];
}
